/* NWAT v2 interactions — vanilla, no deps, respects reduced motion */
/* start after the first frame is on screen, so the hero paints first */
const nwInit = () => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer: fine)').matches;

  /* below-the-fold images: start loading ~600px before they scroll into view, so they don't compete with the hero */
  const lazy = document.querySelectorAll('img[data-nw-src]');
  const show = im => { if (im.dataset.nwSrcset) im.srcset = im.dataset.nwSrcset; im.src = im.dataset.nwSrc; im.removeAttribute('data-nw-src'); im.removeAttribute('data-nw-srcset'); };
  if (!('IntersectionObserver' in window)) lazy.forEach(show);
  else {
    /* load the whole section at once, so carousel slides are ready before they are swiped in */
    const lio = new IntersectionObserver(es => es.forEach(e => { if (!e.isIntersecting) return; const sec = e.target.closest('.shopify-section') || e.target.parentNode; sec.querySelectorAll('img[data-nw-src]').forEach(im => { show(im); lio.unobserve(im); }); }), { rootMargin: '600px 600px' });
    lazy.forEach(im => lio.observe(im));
  }

  /* split headings into words for the rise-in effect (keeps <em> styling) */
  document.querySelectorAll('[data-nw-split]').forEach(el => {
    if (el.dataset.nwDone) return; el.dataset.nwDone = 1;
    const walk = node => {
      [...node.childNodes].forEach(ch => {
        if (ch.nodeType === 3) {
          const frag = document.createDocumentFragment();
          ch.textContent.split(/(\s+)/).forEach(t => {
            if (!t) return;
            if (/^\s+$/.test(t)) { frag.append(t); return; }
            const w = document.createElement('span'); w.className = 'w';
            const i = document.createElement('span'); i.textContent = t; w.append(i); frag.append(w);
          });
          ch.replaceWith(frag);
        } else if (ch.nodeType === 1 && ch.tagName !== 'BR') walk(ch);
      });
    };
    walk(el);
    el.querySelectorAll('.w>span').forEach((s, k) => s.style.transitionDelay = (k * 70) + 'ms');
  });

  /* reveal on scroll */
  const targets = document.querySelectorAll('.nw-reveal,[data-nw-split]');
  if (!('IntersectionObserver' in window) || reduce) targets.forEach(e => e.classList.add('is-in'));
  else {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px 12% 0px' });
    targets.forEach(e => io.observe(e));
  }

  /* header state */
  const hdr = document.querySelector('[data-nw-header]');
  if (hdr) { const f = () => hdr.classList.toggle('is-scrolled', scrollY > 40); f(); addEventListener('scroll', f, { passive: true }); }

  if (fine && !reduce) {
    /* 3D tilt */
    document.querySelectorAll('[data-nw-tilt]').forEach(el => {
      el.addEventListener('pointermove', e => {
        const r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        el.style.transform = `rotateY(${x * 10}deg) rotateX(${-y * 10}deg)`;
      });
      el.addEventListener('pointerleave', () => el.style.transform = '');
    });
    /* magnetic buttons */
    document.querySelectorAll('[data-nw-magnet]').forEach(el => {
      el.addEventListener('pointermove', e => {
        const r = el.getBoundingClientRect();
        el.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .18}px,${(e.clientY - r.top - r.height / 2) * .28}px)`;
      });
      el.addEventListener('pointerleave', () => el.style.transform = '');
    });
    /* bento spotlight */
    document.querySelectorAll('[data-nw-spot]').forEach(el => el.addEventListener('pointermove', e => {
      const r = el.getBoundingClientRect(); el.style.setProperty('--mx', (e.clientX - r.left) + 'px'); el.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }));
  }

  /* flavour stage: scroll-driven colour morph */
  document.querySelectorAll('[data-nw-stage]').forEach(stage => {
    let data = []; try { data = JSON.parse(stage.querySelector('[data-nw-data]').textContent); } catch (e) { return; }
    const imgs = stage.querySelectorAll('.nw-stage__media img'), dots = stage.querySelectorAll('[data-nw-dot]'), steps = stage.querySelectorAll('[data-nw-step]');
    const q = s => stage.querySelector(s), name = q('[data-nw-name]'), ar = q('[data-nw-ar]'), note = q('[data-nw-note]'), ghost = q('[data-nw-ghost]'), idx = q('[data-nw-idx]'), link = q('[data-nw-link]');
    let cur = -1;
    const set = i => {
      if (i === cur || !data[i]) return; cur = i; const d = data[i];
      stage.style.setProperty('--bg', d.bg); stage.style.setProperty('--fg', d.fg);
      imgs.forEach((im, k) => im.classList.toggle('is-on', k === i));
      dots.forEach((b, k) => b.classList.toggle('is-on', k === i));
      name.textContent = d.name; ar.textContent = d.ar; note.textContent = d.note; ghost.textContent = d.name;
      idx.textContent = String(i + 1).padStart(2, '0'); if (d.link) link.href = d.link; const sp = stage.querySelector('[data-nw-sprice]'), sv = stage.querySelector('[data-nw-svid]'), sf = stage.querySelector('.nw-stage__form'); if (sp) sp.textContent = d.price || ''; if (sv && d.vid) sv.value = d.vid; if (sf) sf.hidden = !d.vid;
      if (!reduce) [name, ar, note].forEach(el => el.animate([{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'none' }], { duration: 600, easing: 'cubic-bezier(.2,.8,.2,1)' }));
    };
    set(0);
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) set(+e.target.dataset.nwStep); }), { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach(s => io.observe(s));
    const mob = matchMedia('(max-width:749px)');
    dots.forEach(b => b.addEventListener('click', () => { const i = +b.dataset.nwDot; if (mob.matches) { set(i); b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' }); return; } const s = steps[i]; if (s) scrollTo({ top: s.getBoundingClientRect().top + scrollY - innerHeight * .3, behavior: reduce ? 'auto' : 'smooth' }); }));
    const media = stage.querySelector('.nw-stage__media'); let x0 = null;
    if (media) { media.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      media.addEventListener('touchend', e => { if (x0 === null || !mob.matches) return; const dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) < 40) return; const n = (cur + (dx < 0 ? 1 : -1) + data.length) % data.length; set(n); dots[n] && dots[n].scrollIntoView({ block: 'nearest', inline: 'center' }); }, { passive: true }); }
  });

  /* hero slider */
  document.querySelectorAll('[data-nw-hs]').forEach(hs => {
    const q = s => [...hs.querySelectorAll(s)];
    const copies = q('[data-nw-hs-copy]'), frames = q('[data-nw-hs-frame]'), bgs = q('[data-nw-hs-bg]'), tabs = q('[data-nw-hs-tab]'), tags = q('[data-nw-hs-tag]');
    const num = hs.querySelector('[data-nw-hs-num]'), visual = hs.querySelector('[data-nw-hs-visual]');
    const n = copies.length; if (n < 1) return;
    hs.querySelector('.nw-hs__tabs')?.style.setProperty('--n', n);
    /* split headings into words, staggered */
    hs.querySelectorAll('[data-nw-hs-split]').forEach(h => {
      const walk = node => [...node.childNodes].forEach(ch => {
        if (ch.nodeType === 3) {
          const f = document.createDocumentFragment();
          ch.textContent.split(/(\s+)/).forEach(t => { if (!t) return; if (/^\s+$/.test(t)) { f.append(t); return; } const w = document.createElement('span'); w.className = 'w'; const i = document.createElement('span'); i.textContent = t; w.append(i); f.append(w); });
          ch.replaceWith(f);
        } else if (ch.nodeType === 1 && ch.tagName !== 'BR') walk(ch);
      });
      walk(h); h.querySelectorAll('.w>span').forEach((s, k) => s.style.transitionDelay = (0.12 + k * 0.07) + 's');
    });
    const speed = (+hs.dataset.speed || 7) * 1000, auto = hs.dataset.autoplay === 'true' && !reduce && n > 1;
    if (!auto) hs.classList.add('is-static');
    let cur = 0, timer = null, start = Date.now(), left = speed, paused = false, visible = true, running = false;
    const warm = () => hs.querySelectorAll('.nw-hs__frame img').forEach(im => { im.loading = 'eager'; });
    if (document.readyState === 'complete') setTimeout(warm, 300); else addEventListener('load', () => setTimeout(warm, 300));
    const go = (i, user) => {
      i = (i + n) % n; if (i === cur) return;
      const prev = cur; cur = i;
      copies[prev].classList.add('is-out'); setTimeout(() => copies[prev].classList.remove('is-out'), 500);
      copies.forEach((c, k) => { const on = k === i; c.classList.toggle('is-active', on); c.toggleAttribute('inert', !on); c.setAttribute('aria-hidden', !on); });
      frames.forEach((f, k) => { f.classList.toggle('is-prev', k === prev); f.classList.toggle('is-active', k === i); });
      setTimeout(() => frames[prev]?.classList.remove('is-prev'), 1200);
      bgs.forEach((b, k) => b.classList.toggle('is-active', k === i));
      tags.forEach(t => t.classList.toggle('is-active', +t.dataset.nwHsTag === i));
      tabs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.classList.toggle('is-done', k < i); t.setAttribute('aria-selected', k === i); const b = t.querySelector('.nw-hs__bar i'); if (b) { b.style.animation = 'none'; void b.offsetWidth; b.style.animation = ''; } });
      if (num) { num.classList.add('is-swap'); setTimeout(() => { num.textContent = String(i + 1).padStart(2, '0'); num.classList.remove('is-swap'); }, 350); }
      schedule(speed);
    };
    const schedule = ms => { clearTimeout(timer); running = false; if (!auto) return; left = ms; start = Date.now(); if (!paused && visible) { running = true; timer = setTimeout(() => { running = false; go(cur + 1); }, ms); } };
    const pause = () => { if (paused || !auto) return; paused = true; hs.classList.add('is-paused'); if (running) left = Math.max(400, left - (Date.now() - start)); clearTimeout(timer); running = false; };
    const resume = () => { if (!paused) return; paused = false; hs.classList.remove('is-paused'); schedule(Math.max(400, left)); };
    tabs.forEach((t, k) => t.addEventListener('click', () => go(k, true)));
    hs.querySelector('[data-nw-hs-prev]')?.addEventListener('click', () => go(cur - 1, true));
    hs.querySelector('[data-nw-hs-next]')?.addEventListener('click', () => go(cur + 1, true));
    hs.addEventListener('keydown', e => { if (e.key === 'ArrowRight') go(cur + 1, true); if (e.key === 'ArrowLeft') go(cur - 1, true); });
    hs.addEventListener('focusin', e => { if (e.target.matches(':focus-visible') && !e.target.closest('[data-nw-hs-tab],[data-nw-hs-prev],[data-nw-hs-next]')) pause(); }); hs.addEventListener('focusout', e => { if (!hs.contains(e.relatedTarget)) resume(); });
    document.addEventListener('visibilitychange', () => document.hidden ? pause() : resume());
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; if (!visible) { if (running) left = Math.max(400, left - (Date.now() - start)); clearTimeout(timer); running = false; hs.classList.add('is-paused'); } else if (!paused && !running) { hs.classList.remove('is-paused'); schedule(Math.max(400, left)); } }, { threshold: .2 }).observe(hs);
    /* swipe */
    let sx = null, sy = 0;
    hs.addEventListener('touchstart', e => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    hs.addEventListener('touchend', e => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) go(cur + (dx < 0 ? 1 : -1), true); sx = null; }, { passive: true });
    /* pointer parallax */
    if (fine && !reduce && visual) {
      const fr = visual.querySelector('.nw-hs__frames');
      visual.addEventListener('pointermove', e => { const r = visual.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5; fr.style.transform = `rotateY(${x * 8}deg) rotateX(${-y * 8}deg)`; tags.forEach((t, k) => t.style.translate = `${x * (14 + k * 8)}px ${y * (14 + k * 8)}px`); if (num) num.style.translate = `${-x * 24}px ${-y * 16}px`; });
      visual.addEventListener('pointerleave', () => { fr.style.transform = ''; tags.forEach(t => t.style.translate = ''); if (num) num.style.translate = ''; });
    }
    schedule(speed);
  });

  /* collection: type chips + sort */
  document.querySelectorAll('[data-nw-chips]').forEach(box => {
    const grid = box.closest('section').querySelector('[data-nw-grid]');
    box.addEventListener('click', e => {
      const b = e.target.closest('[data-nw-chip]'); if (!b) return;
      box.querySelectorAll('[data-nw-chip]').forEach(x => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
      const t = b.dataset.nwChip;
      grid.querySelectorAll('[data-type]').forEach(c => c.classList.toggle('is-hidden', t !== '*' && c.dataset.type !== t));
    });
  });
  document.querySelectorAll('[data-nw-sort]').forEach(s => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u; }));

  /* cart page: steppers update the cart */
  document.querySelectorAll('[data-nw-cart]').forEach(form => {
    const sec = form.closest('section'); let t;
    const push = () => { clearTimeout(t); t = setTimeout(async () => {
      sec.classList.add('is-busy');
      const updates = [...form.querySelectorAll('[data-nw-cart-qty]')].map(i => Math.max(0, +i.value || 0));
      try { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) }); } catch (e) {}
      location.reload();
    }, 450); };
    form.querySelectorAll('[data-nw-qty]').forEach(q => {
      const i = q.querySelector('input');
      q.querySelectorAll('[data-nw-q]').forEach(b => b.addEventListener('click', () => { i.value = Math.max(0, Math.min(99, (+i.value || 0) + +b.dataset.nwQ)); push(); }));
      i.addEventListener('change', push);
    });
  });

  /* gift picker */
  document.querySelectorAll('[data-nw-gp]').forEach(gp => {
    const sws = gp.querySelectorAll('[data-nw-gp-sw]'), imgs = gp.querySelectorAll('[data-nw-gp-img]');
    const price = gp.querySelector('[data-nw-gp-price]'), vid = gp.querySelector('[data-nw-gp-vid]'), link = gp.querySelector('[data-nw-gp-link]');
    sws.forEach(sw => sw.addEventListener('click', () => {
      const i = +sw.dataset.nwGpSw;
      sws.forEach((s, k) => { s.classList.toggle('is-on', k === i); s.setAttribute('aria-checked', k === i); });
      imgs.forEach((im, k) => im.classList.toggle('is-on', k === i));
      gp.style.setProperty('--gb', sw.dataset.color);
      if (price && sw.dataset.price) price.textContent = sw.dataset.price;
      if (vid && sw.dataset.vid) vid.value = sw.dataset.vid;
      if (link && sw.dataset.url) link.href = sw.dataset.url;
    }));
  });

  /* ajax add to cart + toast */
  const money = c => (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' SAR';
  let toast;
  const showToast = item => {
    if (!toast) { toast = document.createElement('div'); toast.className = 'nw-toast'; toast.setAttribute('role', 'status'); document.body.append(toast); }
    toast.innerHTML = (item.image ? `<img src="${item.image}&width=120" alt="">` : '') + `<div><b>Added to cart</b><small>${item.product_title}</small></div><a href="/cart">View cart</a>`;
    toast.classList.add('is-on'); clearTimeout(toast.t); toast.t = setTimeout(() => toast.classList.remove('is-on'), 4200);
  };
  const bumpCount = () => fetch('/cart.js').then(r => r.json()).then(c => document.querySelectorAll('.nw-cart-pill b').forEach(b => { b.textContent = c.item_count; b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }));
  document.addEventListener('submit', async e => {
    const f = e.target.closest('[data-nw-add]'); if (!f) return;
    e.preventDefault();
    const btn = f.querySelector('[type=submit]'); btn?.classList.add('is-busy');
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) });
      const d = await r.json(); if (!r.ok) throw new Error(d.description || 'Could not add');
      showToast(d); bumpCount();
      if (btn) { btn.classList.add('is-done'); setTimeout(() => btn.classList.remove('is-done'), 1600); }
    } catch (err) { f.removeAttribute('data-nw-add'); f.submit(); }
    finally { btn?.classList.remove('is-busy'); }
  });

  /* product page: gallery, variants, qty, sticky bar */
  document.querySelectorAll('[data-nw-pdp]').forEach(pdp => {
    const imgs = pdp.querySelectorAll('.nw-pdp__stage .nw-pdp__img'), thumbs = pdp.querySelectorAll('[data-nw-thumb]');
    const show = i => { imgs.forEach((m, k) => m.classList.toggle('is-on', k === i)); thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i)); };
    thumbs.forEach(t => t.addEventListener('click', () => show(+t.dataset.nwThumb)));
    const form = pdp.querySelector('[data-nw-pform]'), vid = pdp.querySelector('[data-nw-vid]');
    let variants = []; try { variants = JSON.parse(pdp.querySelector('[data-nw-variants]').textContent); } catch (e) {}
    const addBtn = pdp.querySelector('[data-nw-addbtn]'), addLabel = pdp.querySelector('[data-nw-addlabel]');
    const update = () => {
      const sel = [...pdp.querySelectorAll('[data-nw-opt]:checked')].map(i => i.value);
      sel.forEach((v, k) => { const l = pdp.querySelector(`[data-nw-optlabel="${k}"]`); if (l) l.textContent = v; });
      const v = variants.find(x => x.options.every((o, k) => o === sel[k])); if (!v) return;
      vid.value = v.id;
      pdp.querySelector('[data-nw-price] span').textContent = money(v.price);
      const sp = pdp.querySelector('[data-nw-sprice]'); if (sp) sp.textContent = money(v.price);
      addBtn.disabled = !v.available; addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      history.replaceState(null, '', location.pathname + '?variant=' + v.id);
      if (v.featured_media) { const i = [...imgs].findIndex(m => m.src.includes((v.featured_media.preview_image.src.split('/').pop() || '').split('?')[0])); if (i > -1) show(i); }
    };
    pdp.querySelectorAll('[data-nw-opt]').forEach(i => i.addEventListener('change', update));
    const qty = pdp.querySelector('[data-nw-qty] input');
    pdp.querySelectorAll('[data-nw-q]').forEach(b => b.addEventListener('click', () => { qty.value = Math.max(1, Math.min(99, (+qty.value || 1) + +b.dataset.nwQ)); }));
    const sticky = pdp.querySelector('[data-nw-sticky]');
    if (sticky && addBtn) {
      new IntersectionObserver(([e]) => { const on = !e.isIntersecting && e.boundingClientRect.top < 0; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', !on); }).observe(addBtn);
      sticky.querySelector('[data-nw-sticky-add]').addEventListener('click', () => form.requestSubmit());
    }
  });

  /* draggable rail */
  document.querySelectorAll('[data-nw-rail]').forEach(rail => {
    let down = false, sx = 0, sl = 0, moved = false;
    rail.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft; rail.classList.add('is-drag'); });
    addEventListener('pointerup', () => { down = false; rail.classList.remove('is-drag'); });
    rail.addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; rail.scrollLeft = sl - dx; });
    rail.addEventListener('click', e => { if (moved) e.preventDefault(); }, true);
    const sec = rail.closest('section'), step = () => (rail.querySelector('.nw-tile,.nw-rail__item')?.offsetWidth || 300) + 22;
    sec?.querySelector('[data-nw-rail-prev]')?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    sec?.querySelector('[data-nw-rail-next]')?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    const prev = sec?.querySelector('[data-nw-rail-prev]'), next = sec?.querySelector('[data-nw-rail-next]');
    const upd = () => { if (prev) prev.disabled = rail.scrollLeft < 4; if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4; };
    rail.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(() => setTimeout(nwInit, 0)));
else requestAnimationFrame(() => setTimeout(nwInit, 0));

/* mobile one-per-view carousels: arrows + counter (2026-10-07) */
(() => {
  const mq = matchMedia('(max-width:989px)');
  const icon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  document.querySelectorAll('.nw-cats__grid,.nw-icons__row,.nw-prail,.nw-crave__grid').forEach(track => {
    const items = [...track.children].filter(el => el.nodeType === 1); if (items.length < 2) return;
    const nav = document.createElement('div'); nav.className = 'nw-mnav';
    nav.innerHTML = '<button type="button" aria-label="Previous">' + icon + '</button><span aria-live="polite"></span><button type="button" aria-label="Next">' + icon + '</button>';
    track.after(nav);
    const [prev, count, next] = nav.children;
    const step = () => (items[1].offsetLeft - items[0].offsetLeft) || track.clientWidth;
    const idx = () => Math.round(track.scrollLeft / step());
    const per = () => Math.max(1, Math.round(track.clientWidth / step()));
    const update = () => { const pages = Math.max(1, items.length - per() + 1), i = Math.min(pages - 1, Math.max(0, idx())); count.textContent = (i + 1) + ' / ' + pages; prev.disabled = i <= 0; next.disabled = i >= pages - 1; };
    const go = d => track.scrollTo({ left: (idx() + d) * step(), behavior: 'smooth' });
    prev.addEventListener('click', () => go(-1)); next.addEventListener('click', () => go(1));
    let t; track.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    const sync = () => { nav.hidden = !mq.matches || track.scrollWidth <= track.clientWidth + 4; update(); };
    addEventListener('resize', sync); setTimeout(sync, 800);
    mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync); sync();
  });
})();

/* close category filter on outside tap */
document.addEventListener('click', e => { document.querySelectorAll('[data-nw-cfilter][open]').forEach(d => { if (!d.contains(e.target)) d.open = false; }); });
